<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="editMode == 'Add'">Add A New</span>
    <span *ngIf="editMode == 'Edit'">Edit A</span>
    <span *ngIf="editMode == 'Copy'">Copy A</span>
    Snippet
  </h4>
</div>
<div class="modal-body">
  <form #snippetForm="ngForm" class="d-flex flex-column h-100" (ngSubmit)="submitForm(snippetForm)">
    <div class="form-floating">
      <input
        type="text"
        ngbAutofocus
        id="snippetTitle"
        required
        name="snippetTitle"
        autocomplete="off"
        [(ngModel)]="snippetTitle"
        #snippetTitleElement="ngModel"
        class="form-control"
        [class.is-invalid]="snippetTitleElement.invalid && snippetTitleElement.touched"
        placeholder="Snippet Name" />
      <label for="snippetTitle">
        Snippet Name
        <small>(required)</small>
      </label>
    </div>
    <div *ngIf="snippetTitleElement.touched">
      <div *ngIf="snippetTitleElement.invalid" class="text-danger">Snippet Name is required</div>
    </div>
    <div class="form-check form-switch mt-3">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="firmLevelSnippet"
        name="firmLevelSnippet"
        [(ngModel)]="sharedSnippet" />
      <label class="form-check-label" for="firmLevelSnippet">Available To Everyone In My Firm</label>
      <i class="bi bi-info-circle-fill m-3"
        triggers="mouseenter:mouseleave"
        popoverTitle="Firm level snippet"
        ngbPopover="Specify whether you would like to share this snippet with everyone in your firm or is only available to you."
        container="body"
        placement="top"
        popoverClass="popover-text-info"></i>
    </div>
    <div class="form-check form-switch mt-3">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="generalSnippet"
        name="generalSnippet"
        [(ngModel)]="generalSnippet" />
      <label class="form-check-label" for="generalSnippet">Generic Document Snippet</label>
      <i class="bi bi-info-circle-fill m-3"
        triggers="mouseenter:mouseleave"
        popoverTitle="Generic document snippet"
        ngbPopover="Specify whether this snippet is only available to insert in any document or just this form."
        container="body"
        placement="top"
        popoverClass="popover-text-info"></i>
    </div>
    <div class="form-floating mt-3">
      <textarea
        id="snippetNote"
        autocomplete="off"
        type="text"
        rows="2"
        class="form-control"
        placeholder="Add any instructions or remarks here."
        [(ngModel)]="snippetNote"
        name="snippetNote"></textarea>
      <label for="snippetNote">
        <i class="bi bi-sticky"></i>
        Snippet Note
        <small>(optional)</small>
      </label>
    </div>
    <editor class="mt-3 flex-grow-1" [init]="init" [(ngModel)]="snippetBody" name="snippetBody"></editor>
  </form>
</div>
<div class="modal-footer pt-0">
  <button
    type="button"
    class="btn btn-sm btn-primary"
    (click)="submitForm(snippetForm)"
    [disabled]="snippetForm.invalid">
    <span *ngIf="editMode == 'Add'">Add</span>
    <span *ngIf="editMode == 'Edit'">Update</span>
    <span *ngIf="editMode == 'Copy'">Copy</span>
    Snippet
  </button>
  <button type="button" class="btn btn-sm btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
</div>
